export enum TenderType {
    /**cash payment */
    Cash = 0,

    /**Payment by bank and other cards. For example, VISA, Master card, and so on. */
    Card = 1,

    /**Payment by voucher. A voucher is a bond of the redeemable transaction type which is worth a certain monetary value and which may be spent only for specific reasons or on specific goods. */
    Voucher = 2,

    /**Payment by customer points, loyalty points, and similar payments. */
    CustomerPoints = 4,

    /**Payment by online payment methods such as PayPal, digital currency such as Bitcoin and similar ... */
    /** Benefit external */
    Virtual = 5,

    /**Payment by cheque or similar payments. For example, cheque, meal vouchers etc. */
    /** Paper voucher, BenefitPaper */
    Cheque = 7,

    /**Payment by electronic voucher, use of specialized benefit payment card on terminal */
    /** Benefit payment card, BenefitCard */
    ElectronicVoucher = 8,

    Other = 9
}    